var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('h4',[_vm._v("Resultados para: "+_vm._s(_vm.querySearch))]),(_vm.results.length > 0)?_c('AllVideos',{attrs:{"filterBySearch":true,"episodesBySearch":_vm.results}}):_c('p',[_vm._v("Tu búsqueda para "+_vm._s(_vm.querySearch)+" no arrojó resultados")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }